/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.tiposUnidades': 'Tipos  Unidades',
'tiposUnidades.agregarTipos Unidades': 'Create Tipos  Unidades',
'tiposUnidades.modificarTipos Unidades': 'Edit Tipos  Unidades',
'tiposUnidades.eliminarTipos Unidades': 'Delete Tipos  Unidades',
'tiposUnidades.tipoUnidadId': 'Tipo   Unidad   Id ',
'tiposUnidades.empresaId': ' Empresa   Id ',
'tiposUnidades.descripcionTipoUnidad': ' Descripcion   Tipo   Unidad',
'tiposUnidades.tipos Unidades': 'Tipos  Unidades',
'tiposUnidades.verTipos Unidades': 'View Tipos  Unidades',
};

